import { Box, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { ProcessStepBar } from "../layout/ProcessStepBar";

interface Props<K extends string> {
  steps: ReadonlyArray<K>;
  currentStep: K;
  navigateToStep: (step: K) => void;
  stepLabel: (step: K) => string;
  stepShortLabel: (step: K) => string;
}

export const WizardStepBar = <K extends string>({
  steps,
  currentStep,
  navigateToStep,
  stepLabel,
  stepShortLabel,
}: Props<K>) => {
  const { t } = useTranslation();
  const currentIndex = steps.indexOf(currentStep);

  return (
    <>
      <Box display={{ base: "none", md: "block" }} overflowX="auto">
        <ProcessStepBar
          maxW="full"
          steps={steps.map((key) => ({ key, label: stepShortLabel(key) }))}
          currentKey={currentStep}
          onStepClick={(key) => navigateToStep(key as K)}
        />
      </Box>
      <Text display={{ base: "block", md: "none" }} fontSize="sm" fontWeight="semibold" color="smPrimary">
        {t("Step")} {currentIndex + 1}/{steps.length} · {stepLabel(currentStep)}
      </Text>
    </>
  );
};
